import React, { ReactNode } from "react";
import gradientPaperStyle from "./gradientPaperStyle";
import { Paper, PaperProps, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

type GradientPaperProps = {
  sx?: SxProps<Theme>;
  children: ReactNode;
} & PaperProps;

export default function GradientPaper({ sx = {}, children, ...rest }: GradientPaperProps) {
  return (
    <Paper sx={{ ...gradientPaperStyle.background, ...sx }} {...rest}>
      {children}
    </Paper>
  );
}
